<div class="checkout-upsell-display-conditions">
  <div class="content">
    <div class="section">
      <pdq-heading element="h5">Display Conditions</pdq-heading>
      <div class="controls-wrapper">
        <span>This Extension Will Only Appear If:</span>
        <pdq-rules-dynamic-form
          [formGroup]="formGroup"
          [formArrayFieldName]="formArrayFieldName"
          [rules]="restrictionsRules | addCurrencyOption: shopCurrencySymbol"
          [entities]="entities"
          [shopCurrencySymbol]="shopCurrencySymbol"
          [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
        <ng-container *ngIf="isAutoRemoveAvailable" [formGroup]="formGroup">
          <pdq-radio-group
            formControlName="whenConditionsNotMet"
            label="When cart no longer meets conditions"
            tooltip="If a customer's cart no longer meets the upsell conditions, choose whether to keep or automatically remove the upsell. Display conditions evaluate the original cart only — items added via upsell are ignored.">
            <pdq-radio-button
              [value]="ConditionsUnmetBehavior.KEEP_IN_CART"
              text="Keep In Cart"
              [checked]="
                formGroup.value['whenConditionsNotMet'] === ConditionsUnmetBehavior.KEEP_IN_CART
              "></pdq-radio-button>
            <pdq-radio-button
              [value]="ConditionsUnmetBehavior.REMOVE_FROM_CART"
              text="Remove From Cart"
              [checked]="
                formGroup.value['whenConditionsNotMet'] === ConditionsUnmetBehavior.REMOVE_FROM_CART
              "></pdq-radio-button>
          </pdq-radio-group>
        </ng-container>
      </div>
    </div>
  </div>
</div>
